// ============================================
// FILE: apiSetup/apiConfig.ts
// ============================================

// Single backend endpoint — no more per-school API URL discovery.
export const API_BASE_URL = 'https://dev-api.skoolpillar.cloud/';
// export const API_BASE_URL = 'https://skoolpillar.space/skoolpillar-gateway-beta/';